import CheckedIcon from "@mui/icons-material/Check";
import UncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { styled } from "@mui/material/styles";

const CheckedListItem = (props) => {
  return (
    <ListItem disablePadding className={props.className}>
      <ListItemIcon className={props.checked ? "checked" : ""}>
        {props.checked ? <CheckedIcon /> : <UncheckedIcon />}
      </ListItemIcon>
      <ListItemText primary={props.text} />
    </ListItem>
  );
};

export default styled(CheckedListItem)(
  ({ theme }) => `
  .MuiListItemIcon-root {
    min-width: 0px;
    margin-right: 8px;
    color: ${theme.palette.tertiary.main};
  }


  .MuiListItemIcon-root.checked {
    color: ${theme.palette.primary.main};
  }
`,
);
